import { put } from "redux-saga/effects";
import axios from "axios";

import {
  fetchUserSuccessful,
  fetchUserFailure,
  logoutSuccessful,
  updatePreferredLanguageSuccessful,
  updatePreferredLanguageFailure,
  createUserSuccessful,
  createUserFailure,
  loginUserSuccessful,
  loginUserFailure,

} from "../../actions/login"; // action
import { FETCH_USER, LOGOUT, UPDATE_PREFFERED_LANGUAGE,SIGNUP, SIGNIN } from "../../../api"; // api
import i18next from 'i18next'
import * as Swal from "sweetalert2";

export function* fetchUser() {
  try {
    const user = yield axios.get(FETCH_USER, { withCredentials: true });
    yield put(fetchUserSuccessful(user.data));
  } catch (error) {
    console.log("error",error)
    yield put(fetchUserFailure());
  }
}

export function* createUser({payload}) {
  try {
    const user = yield axios.post(SIGNUP, payload,{ withCredentials: true });
    console.log("user.data",user.data)

    if(user.data.message === "userRegisterSuccessful"){
                Swal.fire({
                  icon: "success",
                  title: i18next.t('success'),
                  text: i18next.t(user.data.message),
                });

      setTimeout(function() {
        window.location='/login'
      }, 3000);

              } else {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: i18next.t(user.data.message),
                });
              }

    yield put(createUserSuccessful(user.data));

  } catch (error) {
    console.log("error",error)
   // yield put(createUserFailure(error));
  }
}

export function* loginUser({payload}) {
  try {
     const loginUser = yield axios.post(SIGNIN, payload,{ withCredentials: true });
    console.log("loginUser1",loginUser)
    if(loginUser.data.msg){
      yield put(loginUserFailure(loginUser.data.msg));

    } else {
      yield put(loginUserSuccessful(loginUser.data));
      yield fetchUser()
    }

  } catch (error) {
    console.log("error",error)
    yield put(loginUserFailure(error,));
  }
}

export function* updatePreferredLanguage({payload}) {
  try {
    const {data} = yield axios.put(UPDATE_PREFFERED_LANGUAGE, {language: payload},{ withCredentials: true });
    i18next.changeLanguage(data.language)
    yield put(updatePreferredLanguageSuccessful(data.language));
  } catch (error) {
    yield put(updatePreferredLanguageFailure(error));
  }
}

export function* logout() {
  try {
    yield axios.get(LOGOUT, { withCredentials: true });
    yield put(logoutSuccessful());
  } catch (error) {
    //  yield put(logoutSuccessful);
  }
}
